import { PartialRouteObject } from 'react-router';
import Authenticated from 'src/components/Authenticated';
import { Navigate } from 'react-router-dom';
import baseRoutes from './base';
import { lazy, Suspense } from 'react';
import SuspenseLoader from 'src/components/SuspenseLoader';
import { DashboardInterceptor } from './dashbaord.interceptor.index';
import AppInit from 'src/components/AppInit';


const Loader = (Component) => (props) =>
(
  <Suspense fallback={<SuspenseLoader />}>
    <Component {...props} />
  </Suspense>
);

const UpdatePassword = Loader(
  lazy(() => import('src/pages/Auth/UpdatePassword'))
);
const UpdatePasswordSuccess = Loader(
  lazy(() => import('src/pages/Auth/UpdatePassword/success.screen'))
);
const ResetPassword = Loader(
  lazy(() => import('src/pages/Auth/resetPassword'))
);
const ResetPasswordSuccess = Loader(
  lazy(() => import('src/pages/Auth/resetPassword/success.screen'))
);
const Companies = Loader(lazy(() => import('src/pages/Companies')));
const CapTable = Loader(lazy(() => import('src/pages/CapTable')));
const Valuation = Loader(lazy(() => import('src/pages/Valuation')));
const EsopEmployees = Loader(
  lazy(() => import('src/pages/ESOP'))
);
const EsopCreatePlan = Loader(
  lazy(() => import('src/pages/ESOP/CreatePlan')));

const EsopEditPlan = Loader(
  lazy(() => import('src/pages/ESOP/EditPlan')));

const BudgetScreen = Loader(
  lazy(() => import('src/pages/Finance/budget/index'))
);
const BudgetRevenueItemEdit = Loader(
  lazy(() => import('src/pages/Finance/budget/revenueItemEdit'))
);
const DirectCostEdit = Loader(
  lazy(() => import('src/pages/Finance/budget/directCostEdit/index'))
);
const BudgetRevenueItemCreate = Loader(
  lazy(() => import('src/pages/Finance/budget/revenueItemCreate/index'))
);
const BudgetEditItem = Loader(
  lazy(() => import('src/pages/Finance/budget/budgetEditItem'))
);
const DirectCostCreate = Loader(
  lazy(() => import('src/pages/Finance/budget/directCostCreate/index'))
);
const BudgetSideItemCreate = Loader(
  lazy(() => import('src/pages/Finance/budget/budgetSideItemCreate/index'))
);
const BudgetAddOther = Loader(
  lazy(() => import('src/pages/Finance/budget/addOtherFinanceForm/index'))
);

const EmployeesScreen = Loader(
  lazy(() => import('src/pages/HR/Employee/index'))
);
const EmployeesDetailsScreen = Loader(
  lazy(() => import('src/pages/HR/Employee/details/index'))
);
const EmployeesDetailsEdit = Loader(
  lazy(() => import('src/pages/HR/Employee/edit/index'))
);
const EmployeesDetailsCreate = Loader(
  lazy(() => import('src/pages/HR/Employee/create/index'))
);

// Admin
const PagesScreen = Loader(lazy(() => import('src/pages/Admin/pages/index')));

const OrganizationChart = Loader(lazy(() => import('src/pages/HR/OrganizationChart/index')))

const DepartmentsDetailsScreen = Loader(
  lazy(() => import('src/pages/HR/departments/details/index'))
);
const DepartmentsDetailsEdit = Loader(
  lazy(() => import('src/pages/HR/departments/edit/index'))
);
const DepartmentsDetailsCreate = Loader(
  lazy(() => import('src/pages/HR/departments/create/index'))
);
const DepartmentsScreen = Loader(
  lazy(() => import('src/pages/HR/departments/index'))
);
const Login = Loader(lazy(() => import('src/pages/Auth/Login/LoginJWT')));

const Register = Loader(
  lazy(() => import('src/pages/Auth/Register/RegisterJWT'))
);

const RevnueModel = Loader(lazy(() => import('src/pages/RevenuModel/index')));

const AddRevenuModel = Loader(
  lazy(() => import('src/pages/AddRevenu/AddRevenuModel'))
);

const Finance = Loader(lazy(() => import('src/pages/Finance/finance')));

const FinanceRevenueItemCreate = Loader(
  lazy(() => import('src/pages/Finance/finance/revenueItemCreate/index'))
);
const FinanceCostCreate = Loader(
  lazy(() => import('src/pages/Finance/finance/directCostCreate/index'))
);
const FinanceSideItemCreate = Loader(
  lazy(
    () => import('src/pages/Finance/finance/financeSideItemCreateForm/index')
  )
);

const FinanceAddOtherCreate = Loader(
  lazy(() => import('src/pages/Finance/finance/addOtherFinanceForm/index'))
);

const InvestorRelations = Loader(
  lazy(() => import('src/pages/InvestorRelations'))
);

const InvestmentRoundScreen = Loader(
  lazy(() => import('src/pages/Complaince/investment/InvestmentRounds'))
);

const CreateInvestmentRoundScreen = Loader(
  lazy(() => import('src/pages/Complaince/investment/CreateInvestmentRound'))
);

const EditInvestmentRoundScreen = Loader(
  lazy(() => import('src/pages/Complaince/investment/CreateInvestmentRound'))
);

const InvestmentEdit = Loader(
  lazy(() => import('src/pages/Complaince/investment/InvestmentEdit'))
);

const Settings = Loader(lazy(() => import('src/pages/Settings')));

const ProfiteAndLose = Loader(lazy(() => import('src/pages/P&L')));

const ProfiteAndLoseEdit = Loader(lazy(() => import('src/pages/P&L/edit')));

const DashboardScreen = Loader(lazy(() => import('src/pages/Dashboard')));

export const authRoutes: PartialRouteObject[] = [
  {
    path: '/',
    element: <Login />
  },
  {
    path: 'register',
    element: <Register />
  },

  {
    path: 'updatePassword',
    element: <UpdatePassword />
  },
  {
    path: 'updatePassword/success',
    element: <UpdatePasswordSuccess />
  },
  {
    path: 'resetPassword',
    element: <ResetPassword />
  },
  {
    path: 'resetPassword/success',
    element: <ResetPasswordSuccess />
  }
];

export const router: PartialRouteObject[] = [
  {
    path: '/',
    element: <DashboardScreen />
  },
  {
    path: 'departments/:departmentId',
    element: <DepartmentsDetailsScreen />
  },
  {
    path: 'departments/:departmentId/edit',
    element: <DepartmentsDetailsEdit />
  },
  {
    path: 'departments/create',
    element: <DepartmentsDetailsCreate />
  },
  {
    path: 'departments',
    element: <DepartmentsScreen />
  },
  {
    path: 'employees/:employeeId',
    element: <EmployeesDetailsScreen />
  },
  {
    path: 'employees/:employeeId/edit',
    element: <EmployeesDetailsEdit />
  },
  {
    path: 'employees/create',
    element: <EmployeesDetailsCreate />
  },
  {
    path: 'employees',
    element: <EmployeesScreen />
  },
  {
    path: 'organizationChart',
    element: <OrganizationChart />
  },
  {
    path: 'revnueModel',
    element: <RevnueModel />
  },

  {
    path: 'addRevnueModel',
    element: <AddRevenuModel />
  },
  {
    path: 'budget',
    element: <BudgetScreen />
  },

  {
    path: 'budget/budgetRevenueItemCreate',
    element: <BudgetRevenueItemCreate />
  },
  {
    path: 'budget/directCostCreate',
    element: <DirectCostCreate />
  },
  {
    path: 'budget/directCost/:id/:qId',
    element: <DirectCostCreate />
  },
  {
    path: 'budget/budgetRevenueItemCreate',
    element: <BudgetRevenueItemCreate />
  },
  {
    path: 'budget/budgetRevenueItemCreate/:id/:qId',
    element: <BudgetRevenueItemCreate />
  },
  {
    path: 'budget/directCostCreate',
    element: <DirectCostCreate />
  },
  {
    path: 'budget/budgetRevenueItemEdit',
    element: <BudgetRevenueItemEdit />
  },

  {
    path: 'budget/directCostEdit',
    element: <DirectCostEdit />
  },
  {
    path: 'budget/budgetSideItemCreate',
    element: <BudgetSideItemCreate />
  },
  {
    path: 'budget/revenue/:id/:qId',
    element: <BudgetRevenueItemCreate />
  },
  {
    path: 'budget/revenue/:id/editItem',
    element: <BudgetEditItem />
  },
  {
    path: 'finance',
    element: <Finance />
  },

  {
    path: 'finance/FinanceRevenueItemCreate',
    element: <FinanceRevenueItemCreate />
  },
  {
    path: `finance/revenue/:id/:qId`,
    element: <FinanceRevenueItemCreate />
  },
  {
    path: 'finance/FinanceCostCreate',
    element: <FinanceCostCreate />
  },
  {
    path: 'finance/FinanceSideItemCreate',
    element: <FinanceSideItemCreate />
  },
  {
    path: 'finance/addOtherFinanceForm',
    element: <FinanceAddOtherCreate />
  },
  {
    path: `finance/:id/:qId`,
    element: <FinanceAddOtherCreate />
  },
  {
    path: `finance/directCost/:id/:qId`,
    element: <FinanceSideItemCreate />
  },
  {
    path: `finance/budget/directCost/:id/:qId`,
    element: <FinanceSideItemCreate />
  },
  {
    path: `finance/budget/directCost/:id/:qId`,
    element: <BudgetAddOther />
  },

  {
    path: `budget/addAnother/:id/:qId`,
    element: <BudgetAddOther />
  },
  {
    path: `budget/addAnother`,
    element: <BudgetAddOther />
  },
  {
    path: `companies/:id`,
    element: <Companies />
  },
  {
    path: `esop`,
    element: <EsopEmployees />
  },
  {
    path: `esop/createPlan`,
    element: <EsopCreatePlan />
  },
  {
    path: 'esop/:esopId/edit',
    element: <EsopEditPlan />
  },
  {
    path: `capTable`,
    element: <CapTable />
  },
  {
    path: `valuation`,
    element: <Valuation />
  },
  {
    path: 'investorRelations',
    element: <InvestorRelations />
  },
  {
    path: 'investment/round',
    element: <InvestmentRoundScreen />
  },
  {
    path: 'investment/add',
    element: <CreateInvestmentRoundScreen />
  },
  {
    path: 'investment/edit/:id',
    element: <EditInvestmentRoundScreen />
  },

  {
    path: 'investment/round/:id',
    element: <InvestmentEdit />
  },
  {
    path: 'settings',
    element: <Settings />
  },
  {
    path: 'profiteAndLose',
    element: <ProfiteAndLose />
  },
  {
    path: `profiteAndLose/edit/:id/:qId`,
    element: <ProfiteAndLoseEdit />
  },
  {
    path: 'admin/pages',
    element: <PagesScreen />
  }
];
